export default __webpack_public_path__ + "static/media/cientifica4.4dea05e8.jpg";